var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:_vm.isDark ? 'dark' : 'light'},[_c('h2',{class:['header-2', _vm.isDark ? 'dark-header' : 'light-header']},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{class:_vm.isDark ? 'body-dark' : 'body-light',domProps:{"innerHTML":_vm._s(_vm.body)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }